import { MarketFilter } from "../Interfaces";
import { entities } from "sbtech-sports-data-api-client";

export class LeagueMarketFilter implements MarketFilter {
    leagueId: string;
    marketTypeId: string

    constructor(leagueId: string, marketTypeId: string)
    {
        this.leagueId = leagueId;
        this.marketTypeId = marketTypeId;
    }

    isMatch(market: entities.Market): boolean {
        return market.leagueId === this.leagueId;
    }

    isValid(market: entities.Market): boolean {
        return market.marketType.id === this.marketTypeId;
    }
}